import React, { Fragment } from "react";

const RenderBookmakerOdds = ({
  component,
  handelChange,
  odds_lay,
  odds_back,
  item,
  limit,
  disabelBack,
  disabelLay,
  conditionNew,
  oldBack,
  oldLay,
  disableFull,
  ms,
  active,
  betType,
  index,
  disabeLay,
  indexObject,
}) => {
  const chamakBack = (index) => {
    return oldBack?.length > 0
      ? odds_back?.[index]?.rt != oldBack[index]?.rt ||
          odds_back?.[index]?.bv != oldBack[index]?.bv
      : false;
  };
  const chamakLay = (index) => {
    return oldLay?.length > 0
      ? odds_lay?.[index]?.rt != oldLay[index]?.rt ||
          odds_lay?.[index]?.bv != oldLay[index]?.bv
      : false;
  };
  let checkDisabled = (odds) => {
    if (Number(odds) > 0) {
      if (Number(odds) > limit?.oddsLimit) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  return (
    <Fragment>
      {" "}
      <td className colSpan={3}>
        <dl className="back-gradient">
          <dd id="back_3">
            <p>{odds_back?.[2]?.rt || ""}</p>
          </dd>
          <dd id="back_2" style={{ cursor: "pointer" }}>
            <p>{odds_back?.[1]?.rt || ""}</p>
          </dd>
          <dd
            onClick={(e) => {
              if (!disabelBack && ms == 1) {
                if (!checkDisabled(odds_back?.[0]?.rt)) {
                  handelChange(
                    odds_back?.[0],
                    "back",
                    item?.RunnerName || item?.runnerName,
                    item,
                    e
                  );
                }
              }
            }}
            id="back_1"
            className={`${chamakBack(0) ? "spark" : ""} ${
              active && betType == "back" ? "select" : ""
            }`}
            style={{ cursor: "pointer" }}
          >
            <a>{odds_back?.[0]?.rt || ""}</a>
          </dd>
        </dl>
      </td>
      <td className colSpan={3}>
        <dl className="lay-gradient">
          <dd
            onClick={(e) => {
              if (!disabelLay && ms == 1) {
                if (!checkDisabled(odds_lay?.[0]?.rt)) {
                  handelChange(
                    odds_lay?.[0],
                    "lay",
                    item?.RunnerName || item?.runnerName,
                    item,
                    e
                  );
                }
              }
            }}
            className={`${chamakLay(0) ? "spark" : ""} ${
              active && betType == "lay" ? "select" : ""
            }`}
            id="lay_1"
            style={{ cursor: "pointer" }}
          >
            <a>{odds_lay?.[0]?.rt || ""}</a>
          </dd>
          <dd id="lay_2" style={{ cursor: "pointer" }}>
            <p>{odds_lay?.[1]?.rt || ""}</p>
          </dd>
          <dd id="lay_3" style={{ cursor: "pointer" }}>
            <p>{odds_lay?.[2]?.rt || ""}</p>
          </dd>
        </dl>
      </td>
    </Fragment>
  );
};

export default RenderBookmakerOdds;
